import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["a", "p", "strong", "em", "br"];
const ALLOWED_ATTR = ["href"];

/** Minimal server-side fallback (no DOM available during SSR). */
function stripOnServer(html: string): string {
  return html
    .replace(/<\s*(script|style)[\s\S]*?<\s*\/\s*\1\s*>/gi, "")
    .replace(
      /<\/?\s*([a-zA-Z0-9-]+)((?:[^>"']|"[^"]*"|'[^']*')*)>/g,
      (match, tag: string, attrs: string) => {
        if (!ALLOWED_TAGS.includes(tag.toLowerCase())) return "";
        if (match.startsWith("</")) return `</${tag.toLowerCase()}>`;
        const href = /\shref\s*=\s*("([^"]*)"|'([^']*)')/i.exec(attrs);
        const value = href?.[2] ?? href?.[3] ?? "";
        const safe = /^(https?:|mailto:|tel:|\/|#)/i.test(value.trim());
        if (tag.toLowerCase() === "a" && safe) {
          return `<a href="${value.replace(/"/g, "&quot;")}">`;
        }
        return `<${tag.toLowerCase()}>`;
      },
    );
}

export function sanitizeRichText(html: string | null | undefined): string {
  if (!html) return "";
  if (typeof window === "undefined") return stripOnServer(html);
  return DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
}
